import { format } from 'date-fns'
import { th } from 'date-fns/locale'

export function ConvertDateToTH(date: Date): string {
  return format(date, 'dd MMM yyyy - HH:mm', { locale: th })
}

export default ConvertDateToTH
